import { FC } from 'react';
import { Tab as MuiTab, TabProps as MuiTabProps } from '@mui/material';

interface TabProps extends MuiTabProps { }

const Tab: FC<TabProps> = ({ ...props }) => (
  <MuiTab sx={{
    fontFamily: [
      "WorkSans-Variable",
      "Helvetica",
      "Arial",
      "sans-serif"
    ].join(','),
    fontWeight: 400,
    '&.Mui-selected': {
      color: '#000'
    },
  }} {...props} />
);

export default Tab;
